import { render, staticRenderFns } from "./arrow-right.vue?vue&type=template&id=0572f4af"
import script from "./arrow-right.vue?vue&type=script&lang=js"
export * from "./arrow-right.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports